module.exports = __webpack_public_path__ + "static/media/logo-centro-energia.5fde6ab7.jpg";